import { useEffect, useMemo, useRef, useState } from "react";

interface IUseIntervalTextsProps {
  texts: string[];
}

export const useIntervalTexts = ({ texts }: IUseIntervalTextsProps) => {
  const intervalId = useRef<NodeJS.Timer>();
  const [textIndex, setTextIndex] = useState(0);
  const randomText = useMemo(() => texts[textIndex], [textIndex]);

  const handleInterval = () => {
    setTextIndex((prevIndex) => {
      const newIndex = (prevIndex + 1) % texts?.length;

      return newIndex;
    });
  };

  const startIntervalTexts = () => {
    intervalId.current = setInterval(handleInterval, 3000);
  };

  const stopIntervalTexts = () => {
    clearInterval(intervalId?.current);
  };

  useEffect(() => {
    return () => stopIntervalTexts();
  }, []);

  return {
    startIntervalTexts,
    stopIntervalTexts,
    randomText,
  };
};
